import { styled } from '@mui/material/styles';
import TableCell from '@mui/material/TableCell';

export const BodyCell = styled(TableCell, {
  name: 'Table',
  slot: 'TableBodyCell',
})(({ theme, padding }) => ({
  height: '43px',
  minWidth: '50px',
  maxWidth: '250px',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: theme.spacing(1),
  ...(padding === 'none' && { padding: 0 }),
  ...(padding === 'checkbox' && { padding: theme.spacing(0, 1) }),
}));
